export default __webpack_public_path__ + "assets/thermometer-mercury.9e51497f.svg";